import { orientationClassFromObject3D, orientationMatrixForClass } from '../spatial/orientation-profiles.js?v=20260817-relbridge9';
import { primaryComponentList } from './component-slots.js';

export function createSpatialSnapshot({ activeBoxes, engineMode, activePlan }) {
  const activeCase = activeBoxes.find(b=>b.isCase);
  const components=primaryComponentList(activeBoxes).map(comp=>{
    const nodeType=comp.trackType==='aircooler'?'cooler':(comp.trackType==='radiator'?'aio':comp.trackType);
    const orientationClass=Number.isFinite(Number(comp.relationalOrientationClass))?Number(comp.relationalOrientationClass):orientationClassFromObject3D(comp);
    return {
      node_type:nodeType,
      dimensions_mm:[Number(comp.nativeSpecs?.l||0),Number(comp.nativeSpecs?.w||0),Number(comp.nativeSpecs?.h||0)],
      position_mm:[Number(comp.position.x||0),Number(comp.position.y||0),Number(comp.position.z||0)],
      orientation_class:orientationClass,
      orientation_matrix:orientationMatrixForClass(orientationClass),
      orientation_source:comp.relationalOrientationSource||'unknown',
      training_tier:comp.relationalOrientationTrainingTier||'none',
      snap_id:comp.activeSnapId||null,
      snap_source:comp.activeSnapSource||null,
      socket_quarter_turn:comp.trackType==='aircooler'?Number(comp.socketQuarterTurn||0):null,
      is_locked_to_case:!!comp.isLockedToCase
    };
  });
  return {
    schema_version:5,
    spatial_contract_version:5,
    source:'sff_3d_relational_ranked_solver',
    placement_selection_source:activePlan?.placementSelectionSource||'deterministic_fallback',
    gnn_ranking:activePlan?.gnnRanking||null,
    engine_mode:engineMode,
    topology_id:activePlan?.topologyId||null,
    topology_family:activePlan?.layoutFamily||null,
    topology_variant:activePlan?.layoutVariant||null,
    topology_confidence:Number(activePlan?.topologyConfidence||0),
    topology_transform_class:Number.isFinite(Number(activePlan?.transformClass))?Number(activePlan.transformClass):0,
    topology_alternatives:Array.isArray(activePlan?.topologyAlternatives)?activePlan.topologyAlternatives:[],
    topology_reasons:Array.isArray(activePlan?.topologyReasons)?activePlan.topologyReasons:[],
    effective_limits:activePlan?.effective?.limits||null,
    matched_rule_ids:(activePlan?.effective?.matchedRules||[]).map(r=>r.rule_id||r.id).filter(Boolean),
    capability_pool:activePlan?.capabilityProfile?{
      state_count:activePlan.capabilityProfile.states?.length||0,
      motherboard_types:activePlan.capabilityProfile.motherboardTypes||[],
      psu_types:activePlan.capabilityProfile.psuTypes||[],
      width_allocation_pairs:activePlan.capabilityProfile.widthAllocationPairs||[],
      radiator_sizes:activePlan.capabilityProfile.radiatorSizes||[]
    }:null,
    case:activeCase?{
      name:activeCase.nativeSpecs?.name||'',
      dimensions_mm:[Number(activeCase.nativeSpecs?.l||0),Number(activeCase.nativeSpecs?.w||0),Number(activeCase.nativeSpecs?.h||0)],
      declared_layout:activeCase.nativeSpecs?.style||'',
      mode_id:activeCase.spatialState?.modeId||null,
      fixed_step:activeCase.spatialState?.fixedStep||null
    }:null,
    components
  };
}
